<template>
  <section>
    <div class="mod-block" v-loading="loading">
      <h3 class="title">基本信息</h3>
      <el-form ref="form" :model="form" label-width="80px" size="mini" class="mod-form">
        <el-form-item label="商品ID">
          <el-input v-model="form.item" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品类型">{{getComData().typeName}}</el-form-item>
        <!-- 组合商品新增字段 begin -->
        <el-form-item prop="packageItemType" class="label-text" v-if="typeId == '2' || typeId == '3'">
          <span slot="label">
            包组合商品类型
          </span>
          <el-select v-model="form.packageItemType" @change="packageChange" :disabled="disabled.packageItemType">
            <el-option value="V" label="供应商组合打包商品"></el-option>
            <el-option value="B" label="采购员打包组合商品" v-if="typeId == '3'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="form.packageItemType === 'V' && typeId == '2'" label="订购方式"><el-select disabled v-model="form.orderingMethod" disabled></el-select></el-form-item>
        <el-form-item label="订购方式" prop="orderingMethod" v-else-if="typeId == '3'" :rules="[{ required: form.packageItemType == 'B' }]">
          <el-select v-model="form.orderingMethod" disabled>
            <!-- <el-option value="每个" label="每个"></el-option> -->
            <el-option value="p" label="打包组合商品"></el-option>
          </el-select>
        </el-form-item>
        <!-- 组合商品新增字段 end -->
        <template v-if="typeId == '1'">
          <el-form-item label="商品条码" prop="barcode" :rules="[{validator: $validate.required, noRequired: form.autoEan13Ind}]" :required="!form.autoEan13Ind">
            <el-input v-model="form.barcode" :disabled="isbarcodeShow" placeholder="输入690-693开头的13位数字" @change="getBarcode"></el-input>
          </el-form-item>
          <el-form-item label="条码类型" prop="autoEan13Ind" :rules="[{validator: $validate.required, noRequired: form.barcode}]" :required="!form.barcode">
            <el-select v-model="form.autoEan13Ind" :disabled="isautoShow" clearable @change="autoEanChange">
              <el-option value="Y" label="自定义编码">自定义编码</el-option>
              <el-option value="N" label="称重码">称重码</el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item label="一层商品编码"><el-input v-model="form.firstlevelCode" disabled></el-input></el-form-item>
        <el-form-item label="二层商品编码" prop="secondlevelCode" v-if="typeId == '1'">
          <el-input v-model="form.secondlevelCode" disabled></el-input>
        </el-form-item>
        <el-form-item label="商品名称" prop="itemDesc" required :rules="[{validator: $validate.required}, {validator: validateGoods, trigger: 'blur'}]">
          <el-input v-model="form.itemDesc"></el-input>
        </el-form-item>
        <el-form-item label="商品短描述" prop="shortDesc" required :rules="[{validator: $validate.required}, {validator: validateGoods, trigger: 'blur'}]">
          <el-input v-model="form.shortDesc"></el-input>
        </el-form-item>
        <el-form-item label="商品大类" prop="dept">
          <el-select v-model="form.dept" placeholder="请选择" default-first-option filterable @change="selectDept" disabled>
            <el-option v-for="(item,index) in firstClassifyList" :key="index" :label="item.deptId +' '+ item.deptName" :value="item.deptId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品中类" prop="classfoo" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.classfoo" placeholder="请选择" default-first-option filterable @change="selectClassfoo">
            <el-option
              v-for="(item,index) in secondClassifyList"
              :key="index"
              :label="item.classId +' '+ item.className"
              :value="item.classId"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品小类" prop="subclass" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.subclass" placeholder="请选择" default-first-option filterable @change="selectSubclass" :disabled="form.classfoo == ''">
            <el-option
              v-for="(item,index) in thirdClassifyList"
              :key="index"
              :label="item.subclassId +' '+ item.subName"
              :value="item.subclassId"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商品细类" prop="ssubclass" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.ssubclass" placeholder="请选择" default-first-option filterable @change="selectSsubClass" :disabled="form.subclass == ''">
            <el-option
              v-for="(item,index) in fourthClassifyList"
              :key="index"
              :label="item.sclsId +' '+ item.sclsName"
              :value="item.sclsId"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标准单位" prop="standardUom" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.standardUom" filterable @change="standardUomChange">
            <el-option
              v-for="item in standardUomList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="packageSize" required :rules="[{validator: $validate.required}]">
          <span slot="label">
            包装规格
            <el-tooltip content="箱、内包装、外包装对应的数量" placement="top" class="tooltipBtn">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-input v-model="form.packageSize" type="number"></el-input>
        </el-form-item>
        <el-form-item label="" prop="packageUom" required class="label-text" :rules="[{validator: $validate.required}]">
          <span slot="label">包装计量单位
            <el-tooltip content="箱、内包装、外包装的单位" placement="top" class="tooltipBtn">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </span>
          <el-select v-model="form.packageUom" filterable>
            <el-option
              v-for="item in standardUomList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可销售" prop="sellableInd" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.sellableInd">
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可订货" prop="orderable" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.orderable" @change="orderableChange" :disabled="typeId == '2'">
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否可库存" prop="inventoryInd" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.inventoryInd" disabled>
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="零售价(元)" prop="mfgRecRetail" required :rules="[{validator: $validate.required}]">
          <el-input-number v-model="form.mfgRecRetail" :controls="false" :min="0" :precision="2"></el-input-number>
        </el-form-item>
        <el-form-item label="进项税" prop="vatInRate" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.vatInRate">
            <el-option
              v-for="item in vatInRateList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销项税" prop="vatOutRate" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.vatOutRate">
            <el-option
              v-for="item in vatOutRateList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="称重标识" prop="catchWeightInd" required :rules="[{validator: $validate.required}]">
          <el-select v-model="form.catchWeightInd" disabled>
            <el-option value="Y" label="是">是</el-option>
            <el-option value="N" label="否">否</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="经营渠道" prop="channle">
          <el-select v-model="form.channle">
            <el-option
              v-for="item in channleList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="材质" prop="material">
          <el-input v-model="form.material"></el-input>
        </el-form-item>
        <el-form-item label="" prop="targetCost" class="label-text" required :rules="[{validator: $validate.required}]">
          <span slot="label"><i class="mod-tag">供</i>费用目标(元)</span>
          <el-input-number v-model="form.targetCost" :controls="false" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="" prop="salesTarget" class="label-text" required :rules="[{validator: $validate.required}]">
          <span slot="label"><i class="mod-tag">供</i>销售目标(元)</span>
          <el-input-number v-model="form.salesTarget" :controls="false" :min="0"></el-input-number>
        </el-form-item>
        <div class="btns" v-if="!isView"><el-button type="primary" @click="save">保存</el-button></div>
      </el-form>
    </div>
  </section>
</template>
<script>
  export default {
    inject: ['getComData'],
    data () {
      return {
        loading: false,
        disabled: {
          packageItemType: false,
          orderingMethod: false
        },
        isbarcodeShow: false,
        isautoShow:false,
        firstClassifyList: [],
        secondClassifyList: [],
        thirdClassifyList: [],
        fourthClassifyList: [],
        standardUomList: [],
        vatInRateList: [],
        vatOutRateList: [],
        channleList: [],
        isView: this.$route.query._type === 'view',
        form: {
          item: this.$route.query.item || '', // 商品ID
          itemType: '',
          genId: '',
          packageItemType: 'V',
          orderingMethod: '',
          barcode: '',
          autoEan13Ind: '',
          firstlevelCode: '', // 一层商品编码
          secondlevelCode: '',
          itemType: this.id, // 商品类型
          itemDesc: '', // 商品名称
          shortDesc: '', // 商品短描述
          dept: '', // 商品大类
          classfoo: '', // 商品中类
          subclass: '', // 商品小类
          ssubclass: '', // 商品细类
          standardUom: '', // 标准单位
          packageUom: '', // 包装单位
          packageSize: '', // 包装规格
          sellableInd: '', // 是否可销售
          orderable: '', // 是否可订货
          inventoryInd: '', // 是否可库存
          mfgRecRetail: undefined, // 零售价
          vatInRate: '', // 进项税
          vatOutRate: '', // 销项税
          catchWeightInd: '', // 称重标识
          channle: '',
          material: '', // 材质
          targetCost: undefined, // 费用目标(元)
          salesTarget: undefined, // 销售目标(元)
        }
      }
    },
    computed: {
      typeId () {
        return this.getComData().typeId
      }
    },
    methods: {
      standardUomChange () {
        this.form.catchWeightInd = (this.form.standardUom == 'KG') ? 'Y' : 'N'
      },
      orderableChange () {
        // 复杂组合商品
        if (this.typeId == '3') {
          if (this.form.orderable === 'N') {
            this.form.packageItemType = ''
            this.form.orderingMethod = ''
            this.disabled.packageItemType = true
            this.disabled.orderingMethod = true
          } else {
            this.disabled.packageItemType = false
            this.disabled.orderingMethod = false
          }
        }
      },
      packageChange () {
        if (this.form.packageItemType === 'V') {
          this.form.orderingMethod = ''
        } else {
          this.form.orderingMethod = 'p'
        }
      },
      //商品条码有值就清空 店内码
      getBarcode(val){
        if(val != ''){
          this.form.autoEan13Ind = '';
          this.isautoShow = true;
        }else{
          this.isautoShow = false;
        }
      },
      //条码类型有值就清空商品条码
      autoEanChange(val){
        if(val != ''){
          this.form.barcode = '';
          this.isbarcodeShow = true;
        }else{
          this.isbarcodeShow = false;
        }
      },
      validateGoods (rule, value, callback) {
        var reg = /["',|]/
        if (reg.test(value)) {
          this.$message.warning(`不能包含逗号、双引号、单引号、换行、回车、|、TAB等特殊符号`);
          return callback(new Error(` `));
        } else {
          callback();
        }
      },
      //根据供应商id查到供应商类型来判断是否可库存的值
      getSupp () {
        let supp = this.getComData().userInfo.id;
        let para = {
            supplier: supp
        };
        this.$ajax.post('/scm-supp/supplier/selectComposite', para).then(res => {
          if (res && res.result && res.result[0]) {
            this.form.dept = res.result[0].groups;
            this.getSecondCategory(this.form.dept);
          }
        });
      },
      selectDept (event) {
        this.form.classfoo = '';
        this.form.subclass = '';
        this.form.ssubclass = '';
        this.getSecondCategory(event);
      },
      selectClassfoo (event) {
        this.form.subclass = '';
        this.form.ssubclass = '';
        this.getThirdCategory(event)
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      selectSubclass (event) {
        this.form.ssubclass = '';
        this.getFourthCategory(event)
        this.$nextTick(() => {
          this.$refs.form.clearValidate()
        })
      },
      selectSsubClass (event) {
        /* let val = {};
        val = this.fourthClassifyList.find((item)=>{return item.sclsId === event;});
        this.form.ssubclassName = val.sclsName; */
      },
      //商品大类下拉列表
      getFirstCategory() {
        let para = {
          deptId: ' ',
          deptName: ' '
        };
        this.$ajax.post('/commoditymanagement/itemDept/itemDeptList', Object.assign(para, {__isRP: false})).then(rs => {
          this.firstClassifyList = rs.result || []
        });
      },
      //商品中类下拉列表
      getSecondCategory (event) {
        let para = {
          classId: ' ',
          className: ' '
        };
        if (!(event == null || event == undefined || event == "")) {
          para = { deptId: event };
          this.deptDis = false;
        }
        this.$ajax.post('/commoditymanagement/itemClass/getItemClasssList', Object.assign(para, {__isRP: false})).then(res => {
          this.secondClassifyList = res.result;
        });
      },
      //商品小类下拉列表
      getThirdCategory (event) {
        let para = {
          subclassId: ' ',
          subName: ' '
        };
        if (!(event == null || event == undefined || event == "")) {
          para = { classId: event };
        }
        this.$ajax.post('/commoditymanagement/itemScls/itemSclsList', Object.assign(para, {__isRP: false})).then(res => {
          var data = res.result;
          this.thirdClassifyList = data;
        });
      },
      //商品细类下拉列表
      getFourthCategory (event) {
        let para = {};
        if (!(event == null || event == undefined || event == "")) {
          para = { subclassId: event };
          this.sclsDis = false;
        }
        this.$ajax.post('/commoditymanagement/itemSsubCls/itemSsubClsList', Object.assign(para, {__isRP: false})).then(res => {
          var data = res.result;
          this.fourthClassifyList = data;
        });
      },
      save () {
        this.$refs.form.validate(valid => {
          if (valid) {
            let param = JSON.parse(sessionStorage.getItem('application')) || {}
            this.form.itemappId = param.itemappId || '';
            this.form.lastUpdateId = this.getComData().userInfo.id;
            this.form.submitterOwner = this.form.lastUpdateId;
            this.form.itemType = this.typeId
            let url = '/commodityarchives/appItemmasterBaseinfo/insertAppItemmasterBaseinfoNew' // 新增接口
            if (this.form.item) {
              url = '/commodityarchives/appItemmasterBaseinfo/updateAppItemmasterBaseinfoNew' // 更新接口
            }
            this.loading = true
            this.$ajax.post(url, this.form).then(res => {
              if (res && res.code == "0" && res.msg =='success') {
                let result = res.result;
                if (!this.form.item) {
                  this.form.item = result.item;
                }
                let param = {
                  item : this.form.item,
                  dept: this.form.dept
                }
                this.$emit('getItemId',param);
                this.$message({message: "保存成功！", type: "success"});
                this.getInfo()
              } else {
                this.$message.error(`${res.msg}`);
              }
            }).finally(() => {
              this.loading = false
            })
          }
        })
      },
      //根据商品ID查基本信息
      getInfo () {
        if (!this.form.item) {
          return
        }
        let param = {item: this.form.item, __isRP: false}
        return this.$ajax.post('/commodityarchives/appItemmasterBaseinfo/selectAppItemmasterBaseinfoById', param).then(res => {
          if (res && res.code == "0" && res.msg =='success') {
            let result = res.result;
            Object.keys(this.form).forEach(key => {
                this.form[key] = result[key]
            })
            //
            if(this.form.barcode){
              this.isautoShow = true;
              this.isbarcodeShow = false;
            }
            if(this.form.autoEan13Ind){
              this.isautoShow = false;
              this.isbarcodeShow = true;
            }
            // 编辑状态获取三，四级下拉
            this.getThirdCategory(this.form.classfoo);
            this.getFourthCategory(this.form.subclass);
            this.$emit('updated', {data: res.result})
          }
        })
      }
    },
    created () {
      // 非组合类型中是否可库存判断
      if (this.typeId != 2 && this.typeId != 3 ) {
        this.form.inventoryInd = (this.getComData().supplierType === 'LY') ? 'N' : 'Y'
      } else if (this.typeId == 2) {
        this.form.orderable = 'Y'
        this.form.inventoryInd = 'Y'
        this.form.sellableInd = 'N'
      } else if (this.typeId == 3) {
        this.form.inventoryInd = 'Y'
        this.form.sellableInd = 'Y'
        this.form.orderable = 'Y'
      }
      this.getInfo()
      this.getFirstCategory()
      this.getSupp()
      //下拉框数据  包装计量单位 标准单位(和计量单位同个域)
      let keyList = 'packageUom,itemType,vatInRate,vatOutRate'
      this.$ajax.get('/domain-manager/domain/getDomainKeysReturnMapRedis', {keyList}).then(rs => {
        if (rs.data && rs.data.packageUom) {
          this.standardUomList = rs.data.packageUom.listDomainDefine || []
          this.channleList = rs.data.itemType.listDomainDefine || []
          this.vatInRateList = rs.data.vatInRate.listDomainDefine || []
          this.vatOutRateList = rs.data.vatOutRate.listDomainDefine || []
        }
      })
    }
  }
</script>
<style lang="scss" scoped>
  .mod-block {
    background-color: #fff;
    border-radius: 5px;
    padding: 12px 10px 10px;
    overflow: hidden;
    margin-bottom: 10px;
    .title {
      display: flex;
      align-items: center;
      font-size: 14px;
      padding-bottom: 10px;
      &::before {
        display: inline-block;
        content: "";
        height: 1em;
        border: 1px solid #3366ff;
        margin-right: 2px;
      }
    }
  }
  .mod-form {
    .el-form-item {
      float: left;
      width: 190px;
      margin-bottom: 12px!important;
      border: 1px solid #ddd;
      padding: 3px;
      border-radius: 3px;
      margin-right: 10px;
      min-height: 38px;
    }
    /deep/ .label-text .el-form-item__label {
      line-height: 14px;
    }
    /deep/ .el-form-item__label {
      text-align: center;
      padding: 0 0 0 0;
    }
    /deep/ .el-input__inner {
      width: 100px;
    }
    /deep/ .el-form-item__content {
      font-size: 12px;
    }
    .mod-tag {
      background: #8400FF;
      color: #fff;
      border-radius: 4px;
      font-size: 12px;
      font-style: normal;
      padding: 2px;
    }
    .btns {
      float: left;
      padding-top: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/newProductApplication/newpool/add/standard/basic-info.vue